import { Link } from 'react-router-dom';
import {
    Panel,
    PanelBody,
    PanelGrid,
    PanelGridAmount,
    PanelHeader,
    PanelTitle,
    PanelGridItem,
    InvoicePaymentStatus,
    InvoicePaymentInfo,
    PanelLink,
} from 'components';
import { useNavigation } from 'hooks';
import { InvoiceDetailHeaderData, InvoiceSummary } from 'types';
import styles from './InvoiceDetailHeader.module.scss';

type Props = {
    invoiceDetailHeader: InvoiceDetailHeaderData,
    invoice: InvoiceSummary,
}
export default function InvoiceDetailHeader({ invoiceDetailHeader, invoice }: Props) {
    const { invoicesUrl } = useNavigation();

    return (
        <Panel className={styles.panel}>
            <PanelHeader className={styles.header}>
                 <PanelLink>
                    <Link to={invoicesUrl}>Back to Invoices</Link>
                </PanelLink>
                <div className={styles.heading}>    
                    <PanelTitle>
                        {`${invoiceDetailHeader.invoiceId} | ${invoiceDetailHeader.vendorId}`}&nbsp;
                            <InvoicePaymentInfo invoice={invoice}/>
                    </PanelTitle>
                </div>
            </PanelHeader>
            <PanelBody className={styles.body}>
                <PanelGrid>
                    <div className={styles.grid}>
                        <div className={styles.gridItem}>
                            <PanelGridItem
                                label="PO:"
                                value={invoiceDetailHeader.voucherPoId}
                            />
                        </div>
                        <div className={styles.gridItem}>
                            <PanelGridItem
                                label="Payment Status:"
                                value={<InvoicePaymentStatus invoice={invoice} />}
                            />
                        </div>
                        <div className={styles.gridItem}>
                            <PanelGridAmount
                                label="Invoiced:"
                                value={invoiceDetailHeader.invoicedAmount}
                            />
                        </div>
                        <div className={styles.gridItem}>
                            <PanelGridAmount
                                label="Cash Discounts:"
                                value={invoiceDetailHeader.discountAmount}
                            />
                        </div>
                        <div className={styles.gridItem}>
                            <PanelGridAmount
                                label="Adjustments:"
                                value={invoiceDetailHeader.adjAmount}
                            />
                        </div>
                        <div className={styles.gridItem}>
                            <PanelGridAmount
                                label="Paid:"
                                value={invoiceDetailHeader.paidAmount}
                            />
                        </div>
                    </div>
                </PanelGrid>
            </PanelBody>
        </Panel>
    )
}